module.exports = __webpack_public_path__ + "static/media/handelingFee_icon.0fddee33.png";